/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { useForm } from "../../../provider/Form/FormProvider";
import { getCaseLink } from "../../../services/productService";
import TextContainer from "../../Container/TextContainer";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import EmailVerificationModal from "../../FormInfoModal/EmailVerificationModal";
import summaryStyle from "../ContractLaw/Summary/summaryStyle";
import SummaryDetailsItem from "../Common/SummaryDetailsItem/SummaryDetailsItem";

type SummaryProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

const Summary = ({ product, submitProps }: SummaryProps) => {
  const location = useLocation();
  const stateField = location.state?.field;
  const { handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <Paper elevation={4}>
      <TextContainer>
        <Typography variant={"h4"} sx={summaryStyle.headline}>
          Ihre Angaben
        </Typography>
        <Grid container>
          <Box id={"generalCivilLawBase"} sx={summaryStyle.scrollToAnchor} />
          <Grid sx={summaryStyle.subHeadline} size={12}>
            <Typography variant={"h5"}>Ihr Anliegen</Typography>
          </Grid>
          <SummaryDetailsItem fieldPath={"client.gender"} caseData={product} />
          <SummaryDetailsItem fieldPath={"client.givenName"} caseData={product} />
          <SummaryDetailsItem fieldPath={"client.familyName"} caseData={product} />

          <SummaryDetailsItem fieldPath={"customer.telephone"} caseData={product} />

          <Box id={"concernSummary"} sx={summaryStyle.scrollToAnchor} />
          <Grid sx={summaryStyle.subHeadline} size={12}>
            <Typography variant={"h5"}>Zusammenfassung Ihres Anliegens</Typography>
          </Grid>
          <SummaryDetailsItem fieldPath={"personalTextMessage"} caseData={product} />
        </Grid>
        <form onSubmit={handleSubmit}>
          <FormSubmit
            {...submitProps}
            hideBackButton={false}
            backLink={getCaseLink(product) + "/antrag/anliegen"}
            backText={"Alles bearbeiten"}
            nextText={"Angaben speichern"}
          />
        </form>
      </TextContainer>
      <EmailVerificationModal />
    </Paper>
  );
};

export default Summary;
